<template>
  <v-snackbar
    v-if="notification"
    v-model="show"
    :timeout="notification.type === 'error' ? -1 : 3000"
    top
    :color="notification.type"
    class="notification"
  >
    <v-container no-gutters class="pa-0">
      <v-row no-gutters>
        <v-col cols="auto">
          <v-icon left>{{ icon }}</v-icon>
        </v-col>
        <v-col>
          {{ notification.message }}
          <v-btn v-if="notification.action" @click="onActionClick">
            <v-icon left v-if="notification.action.icon">{{notification.action.icon}}</v-icon>
            {{notification.action.label}}
          </v-btn>
        </v-col>
        <v-col cols="auto">
          <v-btn icon  @click="dismiss" class="align-start justify-end">
            <v-icon>mdi-close-circle-outline</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-snackbar>
</template>

<script>
import { MUTATION_DISMISS_NOTIFICATION } from "@/plugins/store";
import commonMixin from "@/mixins/commonMixin";

export default {
  name: "Notification",
  mixins: [commonMixin],
  data: function () {
    return {
      show: true,
    };
  },
  watch: {
    show(val) {
      if (!val) {
        this.dismiss();
      }
    },
  },
  computed: {
    notification: function () {
      return this.$store.state.notification;
    },
    icon: function () {
      return this.getNotificationIcon(this.$store.state.notification.type);
    },
  },
  methods: {
    onActionClick() {
      this.$eventBus.$emit(this.notification.action.event, this.notification.action.eventData)
      this.dismiss()
    },
    dismiss() {
      this.$store.commit(MUTATION_DISMISS_NOTIFICATION);
    },
  },
  created: function () {
    this.$store.watch(
      (state) => state.notification,
      () => {
        if (this.$store.state.notification) {
          this.show = true;
        }
      }
    );
  },
};
</script>

<style scoped>
.notification {
  margin-top: 2.9em;
}
</style>
